export const ASSIGN_RIDER_ERROR_CODE = {
  VRD02: 'VRD02',
  VRD03: 'VRD03',
};
